/* pdp-lives-back: continuous photo marquee. Two identical tracks; the copy starts at +100% and both slide left,
   duration = track width / speed (px per second, desktop vs mobile). Smooth-scroll for the Claim Offer anchor. */
if (!customElements.get('pdp-lives-back')) {
  class PdpLivesBack extends HTMLElement {
    connectedCallback() {
      this.ac = new AbortController();
      const track = this.querySelector('.pd-lives-back__track');
      if (!track) return;
      const setDuration = () => {
        const mobile = window.innerWidth < 992;
        const speed = parseFloat(this.getAttribute(mobile ? 'data-speed-mobile' : 'data-speed')) || (mobile ? 50 : 85);
        const width = track.getBoundingClientRect().width;
        if (width > 0) { this.style.setProperty('--pd-lb-duration', (width / speed).toFixed(2) + 's'); this.classList.add('is-ready'); }
      };
      setDuration();
      const ro = new ResizeObserver(setDuration); ro.observe(track); this.ro = ro;
      this.querySelectorAll('img').forEach(img => { if (!img.complete) img.addEventListener('load', setDuration, { once: true, signal: this.ac.signal }); });
      window.addEventListener('resize', setDuration, { signal: this.ac.signal });
    }
    disconnectedCallback() { this.ac && this.ac.abort(); this.ro && this.ro.disconnect(); }
  }
  customElements.define('pdp-lives-back', PdpLivesBack);
}
document.addEventListener('click', (e) => {
  const a = e.target.closest('.pd-lives-back a[data-pdp-scroll]');
  if (!a) return;
  const hash = a.getAttribute('href') || '';
  if (!hash.startsWith('#')) return;
  const target = document.querySelector(hash);
  if (!target) return;
  e.preventDefault();
  // Horizon scrolls the page inside .page-wrapper on desktop (html/body are overflow hidden ≥990px), so scrollIntoView is the only method that works everywhere.
  target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
});
